import { render, staticRenderFns } from "./PurchaseTimeComponent.vue?vue&type=template&id=4b36edd0"
import script from "./PurchaseTimeComponent.vue?vue&type=script&lang=ts"
export * from "./PurchaseTimeComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports